module.exports = __webpack_public_path__ + "static/media/working_from_home.48863c33.png";